<template>
  <div v-bind:class="['row', name]" style="height: 50px">
    <div class="col-2 corner-rl icon"><base-icon v-bind:name="(icon? icon: name)" /></div>
    <div class="col-2"                  v-bind:class="{ zero: (data.total == 0) }">{{ data.total }}</div>
    <div class="col-2 late"             v-bind:class="{ zero: (data.late == 0) }">{{ data.late }}</div>
    <div class="col-2 at-risk"          v-bind:class="{ zero: (data.atRisk == 0) }">{{ data.atRisk }}</div>
    <div class="col-2 on-time corner-r" v-bind:class="{ zero: (data.onTime == 0) }">{{ data.onTime }}</div>
    <div class="col-2 upcoming"         v-bind:class="{ zero: (data.upcoming == 0) }"><div>{{ data.upcoming }}</div></div>
  </div>
</template>

<script>
import Vue from 'vue'

import BaseIcon from '../../components/icons/BaseIcon.vue'

export default {
  name: 'ActiveShipmentsRow',
  props: ['name', 'icon', 'data'],
  components: {
    BaseIcon
  },
}
</script>



// WEBPACK FOOTER //
// ActiveShipmentsRow.vue?0057f844